<template>  
  <div class="flex flex-col h-full w-full gap-2"> 
    <!-- <div class="max-h-[56px] max-w-[360px]">
        <Button label="Создать" icon="pi pi-plus-circle" class="mr-2" @click="createTransaction" />
    </div>   -->
    <div class="cursor-pointer">
      <DataTable          
        class="no-rounded-thead"
        :value="transactions"
        :key="selectedDocument ? selectedDocument.guid : 'no-selection'"
        :rows="rows"
        :loading="loading"
        showGridlines 
        stripedRows 
        scrollable 
        scrollHeight="calc(50vh - 70px)"
        responsiveLayout="scroll"      
        :rowClass="getRowClass"
        @row-click="onRowClick"                
      >      
        <Column field="date" header="Дата" style="width: 115px; min-width: 100px" :bodyStyle="{ textAlign: 'center' }" />
        <Column field="sender.name" header="Плательщик" style="min-width: 132px" :bodyStyle="{ textAlign: 'center' }" />
        <Column field="recipient.name" header="Получатель" style="min-width: 132px" :bodyStyle="{ textAlign: 'center' }" />      
        <Column header="Сумма" style="width: 130px; min-width: 100px" :bodyStyle="{ textAlign: 'center' }">
          <template #body="slotProps">
            <span>{{ formatNumber(slotProps.data.sum) + ' ' + slotProps.data.currencyName }}</span>
          </template>
        </Column>
        <!-- <Column field="currencyName" header="Валюта" style="width: 95px" :bodyStyle="{ textAlign: 'center' }" /> -->
        <!-- <Column field="description" header="Описание" style="min-width: 130px" :bodyStyle="{ textAlign: 'center' }" />         -->
        <Column header="" style="width: 5px;">
          <template #body="{ data }">          
            <div class="delete-wrapper flex flex-row">
              <Button
                icon="pi pi-pen-to-square"
                severity="secondary"
                text
                rounded
                @click.stop="onChangeRow(data)"
              />
              <Button
                v-if="!data.readOnly && !readOnly"
                icon="pi pi-trash"
                severity="danger"
                text
                rounded
                @click.stop="onDeleteConfirm(data)"
              />
            </div>
          </template>
        </Column>     
      </DataTable>    
    </div>
      
    <Paginator
      :rows="rows"
      :totalRecords="totalRecords"
      :rowsPerPageOptions="[10, 20, 30]"
      first.sync="first"
      @page="onPage"
      class="mt-3"
    />    

    <Dialog
      v-model:visible="transactionDialogVisible"
      @update:visible="onDialogVisibleChange"
      :header="dialogTitle"
      :modal="true"
      :style="{ width: '450px' }"
    >    
        <Transaction 
          :document="selectedDocument" 
          @create="onCreateTransaction" 
          @update="onUpdateTransaction" 
          @delete="onDeleteTransaction" 
        />     
    </Dialog>

    <Dialog
      v-model:visible="descriptionDialogVisible"
      @update:visible="onDialogVisibleChange"
      :header="dialogTitle"
      :modal="true"
      :style="{ width: '550px' }"
    >    
      <div class="w-full max-w-[450px]">
          <Textarea 
            v-model="selectedDocument.description" 
            rows="4" 
            size="small" 
            placeholder="Описание" 
            class="w-full max-w-[450px]" 
            style="resize: none" 
            readonly
          /> <!-- :readonly="selectedDocument?.readOnly"     -->
      </div>                                 
    </Dialog>

    <ConfirmDialog />
  </div>
</template>

<script>
  import DataTable from 'primevue/datatable';
  import Column from 'primevue/column';
  import Paginator from 'primevue/paginator';
  import Dialog from 'primevue/dialog';
  import Button from 'primevue/button';
  import Textarea from 'primevue/textarea';
  import ConfirmDialog from 'primevue/confirmdialog';
  // import { confirmDialog } from 'primevue/api';
  import { TransfersService } from '@/services/transfers';
  import Transaction from '@/pages/transactions/components/Transaction.vue';
  
  export default {
    name: 'TransactionTable',
    components: {
      DataTable,
      Column,
      Paginator,
      Dialog,
      Button,
      Textarea,
      ConfirmDialog,
      Transaction,
    },
    props: {
        readOnly: {
            type: Boolean,
            default: false
        }        
    },

    data() {
      return {
        transactions: [],
        totalRecords: 0,
        rows: 10,
        first: 0,
        loading: false,
        transactionDialogVisible: false,
        descriptionDialogVisible: false,
        selectedDocument: null,  
        savedScrollTop: 0,      
      };
    },

    mounted() {
      this.loadData();
    },

    computed: {
      dialogTitle() {
        return this.selectedDocument
          ? 'Перевод ДС от ' + this.selectedDocument.date
          : 'Перевод ДС';
      }
    },

    watch: {
      selectedDocument: {
        handler(newVal, oldVal) {
          this.saveScrollPosition();
          this.$nextTick(() => {
            this.restoreScrollPosition();
          });
        },
        immediate: false,
      },
    },

    methods: {
      async loadData() {
        this.loading = true;
        try {
          const limit = this.rows;
          const offset = this.first;
  
          const response = await TransfersService.getList(limit, offset);            

          this.transactions = response.data.data;
          this.totalRecords = response.data.total;
        } catch (error) {
          this.error = e.message;
          console.log(e);
        } finally {
          this.loading = false;
        }
      },
    
      onPage(event) {
        this.first = event.first;
        this.rows = event.rows;
        this.loadData();
      },

      onRowClick(event) {
        //this.openSelectedDocument(event.data);
        this.selectedDocument = event.data;
        this.descriptionDialogVisible = true;        
      },  

      openSelectedDocument(data) {
        this.selectedDocument = data;
        this.transactionDialogVisible = true;
      },
      
      // открываем окно создания документа
      createTransaction() {
        this.selectedDocument = null;
        this.transactionDialogVisible = true;        
      },

      onChangeRow(data) {
        this.openSelectedDocument(data);  
      },

      async onDelete(guid) {
        this.loading = true;

        try {
          await TransfersService.delete(guid);
          await this.loadData(); 
        } catch (error) {
          this.error = error.message;
          console.log(error);
        } finally {
          this.loading = false;           
        }
      },           

      onDeleteConfirm(data) {
        this.selectedDocument = data;
        this.$confirm.require({
          message: 'Вы уверены, что хотите удалить документ?',
          header: 'Подтверждение удаления',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: 'Да',
          rejectLabel: 'Нет',
          accept: () => this.onDelete(data.guid),
          onHide: () => {
            this.selectedDocument = null;
          }
        });
      },

      // обрабатываем событие создания нового документа - закрываем форму и обновляем таблицу
      onCreateTransaction() { 
        this.selectedDocument = null;
        this.transactionDialogVisible = false;        
        this.loadData();
      },

      onUpdateTransaction() {
        this.selectedDocument = null;
        this.transactionDialogVisible = false;      
        this.loadData();
      },

      onDeleteTransaction() { 
        this.selectedDocument = null;
        this.transactionDialogVisible = false;        
        this.loadData();
      },     
      
      onDialogVisibleChange(visible) {
        if (!visible) {
          this.selectedDocument = null;
        }
      },
      
      // выделяем строку выбранного документа
      getRowClass(data) {                 
        return {
          'selected-row': this.selectedDocument && this.selectedDocument.guid === data.guid
        }
      },

      formatNumber(num) {        
            return this.$formatNumber(num)
      },    

      saveScrollPosition() {
        const scrollBody = this.$el.querySelector('.p-datatable-scrollable-body');
        if (scrollBody) {
          this.savedScrollTop = scrollBody.scrollTop;
        }
      },

      restoreScrollPosition() {
        const scrollBody = this.$el.querySelector('.p-datatable-scrollable-body');
        if (scrollBody && this.savedScrollTop != null) {
          scrollBody.scrollTop = this.savedScrollTop;
        }
      },
    },
  };
</script>
  
<style>
  .selected-row {    
    box-shadow: inset 0 0 0 3px var(--p-primary-100);
  }

  .flex-1 {
    flex: 1 1 auto;
    min-height: 0; 
  }

  .flex-1.overflow-auto {
    min-height: 0; 
  }
</style>
  